import { StandingAccessReportEntitlementLinkedElementFragmentFragment } from '@api/gql/graphql';
import AssessmentReportIdentity from './AssessmentReportIdentity';
import PrimarySecondary from '@common/ui/PrimarySecondary';

export interface AssessmentReportConnectionProps {
  connection: StandingAccessReportEntitlementLinkedElementFragmentFragment;
}

export default function AssessmentReportConnection({ connection }: AssessmentReportConnectionProps) {
  if (connection.type === 'GROUP') {
    return <PrimarySecondary primary={connection.name} secondary="Group" />;
  }

  if (connection.type === 'USER') {
    return <AssessmentReportIdentity name={connection.name} email={connection.id} />;
  }

  return null;
}
